<template>
  <responsive-component
    v-observe-visibility="configVisibility"
    :aspect-ratio="aspectRatio"
    :content-class="contentClass"
    :content-style="contentStyle"
  >
    <!--
 -->
    <!-- <div
      v-if="!isLoaded"
      class="animated d-flex align-items-center full-space justify-content-center"
    >
      <i class="fas fa-3x fa-spinner fa-pulse"/>
    </div>-->
    <!-- NOTE:  loading="lazy" - make the same as lazy loading based on InteractionAPI-->
    <!-- The loading attribute allows a browser to defer loading offscreen images and iframes until users scroll near them. loading supports three values:
          lazy: is a good candidate for lazy loading.
          eager: is not a good candidate for lazy loading. Load right away.
          auto: browser will determine whether or not to lazily load.
    Not specifying the attribute at all will have the same impact as setting loading=auto.-->
    <img
      v-bind="$attrs"
      :src="imageChange"
      :style="imgStyle"
      :alt="altText"
      class="responsive-image"
      :class="imgClass"
      loading="eager"
      @error="setError"
      @load="loaded()"
    >

    <!-- TODO: exemple for srcset -->
    <!-- <img
        v-bind="$attrs"
        :src="image"
        :srcset="srcSetText"
        sizes="(max-width: 599px) 100vw,
               (min-width: 600px) and (max-width: 959px) 50vw,
               (min-width: 960) 30vw"
        :style="imgStyle"
        :alt="altText"
        class="ugc-image-img"
        @error="setError"
        @load="loaded()"
    >-->
    <!-- <slot/> -->
    <template v-slot:additionally>
      <slot/>
    </template>
  </responsive-component>
</template>
<script>
  import normaliseImg from 'src/filters/normalizeImg.js';
  import responsiveComponent from './responsive.vue';
  import { isString, isNil } from 'lodash';
  import Loader from 'src/components/loader/loader.vue';
  import device from 'src/service/device-service.js';

  export default {
    name: 'UgcImage',
    components: {
      Loader,
      responsiveComponent,
    },
    props: {
      src: {
        required: true,
        validator: value => isNil(value) || isString(value),
      },
      alt: {
        validator: value => isNil(value) || isString(value),
        default: null,
      },
      aspectRatio: {
        type: [String],
        default: '16x9',
        validator: type => {
          // The value should be '16x9', '9x16', ...etc;
          return isString(type) && type.toLowerCase().indexOf('x') > -1;
        },
      },
      resolutionType: {
        type: String,
        default: 'thumb',
        validator: t => {
          return t && ['thumb', 'image'].indexOf(t) > -1;
        },
      },

      forceResolutionType: {
        type: Array,
        default: () => [],
      },

      imgClass: {
        type: String,
        default: null,
      },
      contentClass: {
        type: String,
        default: null,
      },
      contentStyle: {
        type: Object,
        default: () => ({}),
      },

      //https://css-tricks.com/almanac/properties/o/object-fit/
      size: {
        type: String,
        default: 'fill',
        validator(val) {
          let vals = ['fill', 'cover', 'contain', 'none', 'scale-down'];
          return vals.indexOf(val) > -1;
        },
      },
      // https://css-tricks.com/almanac/properties/o/object-position/
      position: {
        type: String,
        default: 'center',
        // validator(val) {
        //   let vals = ['top', 'center', 'bottom'];
        //   return vals.indexOf(val) > -1;
        // },
      },
    },
    data() {
      return {
        image: null,
        isLoaded: true,
        isError: false,
        isVisible: false,
        wasVisible: false,
      };
    },
    computed: {
      isUsedErrorImage() {
        return null; //this.config.notLoaded;
      },
      isUsedNotSetImage() {
        return null; //this.config.notFound;
      },
      errorImage() {
        return  this.isUsedErrorImage
          ? normaliseImg('error')
          : normaliseImg(this.src);
      },
      unsetImage() {
        return this.isUsedNotSetImage ? normaliseImg(null) : null;
      },
      imgStyle() {
        return {
          'object-fit': this.size,
          'object-position': this.position,
          opacity: this.isLoaded ? 1 : 0.3,
          filter: this.isLoaded ? 'unset' : `blur(5px)`,
        };
      },

      altText() {
        return !this.src
          ? 'Image is not set'
          : this.isError
            ? `Image ${
              process.env.NODE_ENV === 'development' ? this.image : ''
            } not loaded.`
            : this.alt;
      },

      imageChange() {
        // console.log(this.image, !this.isVisible  !this.isLoaded);
        if ((!this.isVisible && !this.wasVisible) || !this.isLoaded) {
          return this.imagePlaceholder;
        }
        return this.image;
      },

      configVisibility() {
        return {
          callback: this.changeVisibility,
          intersection: {
            rootMargin: '320px',
          },
        };
      },
      // srcSetText() {
      //   if (this.image && this.src) {
      //     let rpl = (src, txt) => src.replace(`original`, txt).replace('.png', '.jpg');
      //     return `${rpl(this.src, 'ED')} 400w,
      //             ${rpl(this.src, 'SD')} 800w,
      //             ${rpl(this.src, 'HD')} 1200w,
      //     `;
      //   } else {
      //     return null;
      //   }
      // },

      imagePlaceholder() {
        let type = this.src? this.src.indexOf('poster') > -1? [9, 16] : this.src.indexOf('backdrop') > -1? [16, 9] : [1, 1] : this.aspectRatio.toLowerCase().split('x');
        return `data:image/svg+xml;utf8,
        <svg viewBox="0 0 ${type[0]} ${type[1]}" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <rect x="0" y="0" width="${type[0]}" height="${type[1]}" stroke="none" fill="transparent"/>
        </svg>`;
      },
    },
    // mounted() {
    //   this.isVisible = this.isInViewport(this.$el);
    //       },
    // updated() {
    //   this.isVisible = this.isInViewport(this.$el);
    //       },
    watch: {
      src: {
        immediate: true,
        handler: function() {
          this.changeImage();
        },
      },
    },
    methods: {
      loaded() {
        // this.$logger.log(`Image ${this.src} is loaded`);
        this.isLoaded = true;
        this.isError = false;
      },
      setError() {
        // this.$logger.log(`Image ${this.src} has error`);
        this.isLoaded = true;
        this.isError = true;
        this.image = this.errorImage;
      },

      changeVisibility(visible, entry) {
        this.isVisible = visible;
        if (this.isVisible) {
          this.wasVisible = true;
        }
      },

      isInViewport(elem) {
        var bounding = elem.getBoundingClientRect();
        // console.log(bounding.top >= 0, bounding.left >= 0, bounding.bottom <=
        //     (window.innerHeight || document.documentElement.clientHeight),  bounding.right <=
        //     (window.innerWidth || document.documentElement.clientWidth));
        return (
          bounding.top >= 0 &&
          bounding.left >= 0 &&
          bounding.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
          bounding.right <=
          (window.innerWidth || document.documentElement.clientWidth)
        );
      },

      changeImage() {
        let tablet =
          device.isAnyMobile() &&
          !device.isMobileSize() &&
          this.forceResolutionType.length > 2
            ? this.forceResolutionType[2]
            : this.forceResolutionType[0];
        let mob =
          this.forceResolutionType && this.forceResolutionType.length < 2
            ? undefined
            : tablet;
        let desktop =
          this.forceResolutionType && this.forceResolutionType.length < 2
            ? undefined
            : this.forceResolutionType[1];
        this.image = this.src
          ? normaliseImg(this.src, this.resolutionType, desktop, mob)
          : this.unsetImage;
        this.isError = false;
        this.isLoaded = !this.image;
      },
    },
  };
</script>

<style lang="scss">
.responsive-image {
  width: 100%;
  height: 100%;
  transition: opacity 300ms ease-in, filter 300ms ease-in;
}

.responsive-loader {
  height: 100%;
  width: 100%;
}
</style>

